import { t } from '@/plugins/i18n'
const returnDefectiveText = (code: string) => {
  const codeList = code.split(',')
  const text = defectiveList.filter(item => codeList.includes(String(item.value))).reduce((text, item) => {
    return text + t(item.text) + '，'
  }, '')
  return text.slice(0, text.length - 1)
}

export default returnDefectiveText

const defectiveList = [
  {
    value: 0,
    text: '正常'
  },
  {
    value: 101,
    text: '到错货'
  },
  {
    value: 102,
    text: '少件'
  },
  {
    value: 103,
    text: '多件'
  },
  {
    value: 201,
    text: '颜色差异'
  },
  {
    value: 202,
    text: '商品上有中文'
  },
  {
    value: 203,
    text: '配件差异（口袋, 腰带, 纽扣, 拉链, 拉绳等）'
  },
  {
    value: 204,
    text: 'logo差异'
  },
  {
    value: 205,
    text: '尺码差异'
  },
  {
    value: 206,
    text: '设计差异（压线，领口，袖口，花纹，衣服设计等）'
  },
  {
    value: 207,
    text: '材质/面料差异'
  },
  {
    value: 301,
    text: '色差'
  },
  {
    value: 302,
    text: '污渍/斑点/水印'
  },
  {
    value: 303,
    text: '破损'
  },
  {
    value: 304,
    text: '线头'
  },
  {
    value: 305,
    text: '接缝不良'
  },
  {
    value: 306,
    text: '抽丝'
  },
  {
    value: 307,
    text: '针眼'
  },
  {
    value: 308,
    text: '霉菌'
  },
  {
    value: 309,
    text: '生锈'
  },
  {
    value: 310,
    text: '商品有中文'
  },
  {
    value: 311,
    text: '纽扣破损'
  },
  {
    value: 312,
    text: '拉链破损'
  },
  {
    value: 313,
    text: '附属品缺陷'
  },
  {
    value: 314,
    text: '有气味'
  },
  {
    value: 315,
    text: '其他不良'
  }
]
